<template>
  <div>
    <el-alert type="info" :closable="false" show-icon class="u-mb-10">
      <div slot="title">Só aparece ao cidadão o serviço PUBLICADO com destino válido</div>
      <div class="obs">
        Item sem destino, com nó excluído ou com nó inativo some da carta pública — e aparece
        abaixo, em "problemas". É assim que o link quebrado deixa de ser silencioso.
      </div>
    </el-alert>

    <el-row :gutter="10">
      <el-col :xs="24" :sm="14">
        <c-panel title="Carta de serviços" titleIcon="fas fa-list">
          <div v-if="carregando" class="estado"><i class="el-icon-loading"></i> carregando…</div>
          <div v-else-if="!itens.length" class="estado" data-test="carta-vazia">Nenhum serviço cadastrado.</div>
          <table v-else class="table table-striped" data-test="tabela-carta">
            <thead><tr><th>Serviço</th><th>Destino</th><th style="width:90px">Situação</th><th style="width:150px"></th></tr></thead>
            <tbody>
              <tr v-for="i in itens" :key="i.id">
                <td>{{ i.titulo }}<div class="obs">{{ i.categoria }}</div></td>
                <td>{{ i.no_chave || '—' }}</td>
                <td>
                  <el-tag size="mini" :type="i.publicado ? 'success' : 'info'">
                    {{ i.publicado ? 'publicado' : 'rascunho' }}
                  </el-tag>
                </td>
                <td>
                  <el-button type="text" size="mini" @click="editar(i)">editar</el-button>
                  <el-button class="u-ml-10" v-if="!i.publicado" type="text" size="mini"
                             @click="publicar(i)" data-test="btn-publicar-servico">publicar</el-button>
                  <el-button class="u-ml-10" v-else type="text" size="mini" @click="despublicar(i)">despublicar</el-button>
                  <el-button class="u-ml-10" type="text" size="mini" @click="remover(i)">remover</el-button>
                </td>
              </tr>
            </tbody>
          </table>
        </c-panel>

        <c-panel v-if="problemas.length" title="Itens que NÃO chegam ao cidadão"
                 titleIcon="fas fa-unlink" class="u-mt-10">
          <table class="table table-striped" data-test="tabela-problemas">
            <tr v-for="p in problemas" :key="p.id">
              <td>{{ p.titulo }}</td>
              <td class="motivo">{{ p.motivo }}</td>
            </tr>
          </table>
        </c-panel>
      </el-col>

      <el-col :xs="24" :sm="10">
        <c-panel :title="form.id ? 'Editando serviço' : 'Novo serviço'" titleIcon="fas fa-edit">
          <el-form label-position="top" size="small">
            <el-form-item label="Categoria"><el-input v-model="form.categoria"></el-input></el-form-item>
            <el-form-item label="Título">
              <el-input v-model="form.titulo" data-test="campo-titulo"></el-input>
            </el-form-item>
            <el-form-item label="Descrição">
              <el-input type="textarea" :rows="3" v-model="form.descricao"></el-input>
            </el-form-item>
            <el-form-item label="Nó de destino">
              <el-select v-model="form.no_destino_id" style="width:100%" filterable
                         data-test="campo-destino">
                <el-option v-for="n in nos" :key="n.id" :value="n.id"
                           :label="n.chave + ' (' + n.tipo + ')'"></el-option>
              </el-select>
              <div class="obs">Publicar exige destino existente, ativo e em fluxo publicado.</div>
            </el-form-item>
          </el-form>

          <el-alert v-if="erro" type="error" :closable="false" show-icon class="u-mb-10"
                    data-test="erro-servico" :title="erro"></el-alert>

          <el-button size="small" type="primary" :loading="salvando" @click="salvar"
                     data-test="btn-salvar-servico">SALVAR</el-button>

          <!--
            O painel é o único caminho para criar: sem esta saída, quem clicasse em "editar"
            ficaria preso no registro, porque não há outro lugar que limpe o formulário.
          -->
          <el-button v-if="form.id" size="small" class="u-ml-10" @click="novo"
                     data-test="btn-cancelar-edicao">CANCELAR EDIÇÃO</el-button>
        </c-panel>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/** FASE 5 / AV-3 — AV 14: carta de serviços pela interface. */
import assistenteApi from '../assistenteApi'

export default {
  data () {
    return {
      api: null, itens: [], problemas: [], nos: [], carregando: false,
      form: this.vazio(), erro: null, salvando: false
    }
  },
  mounted () {
    this.api = assistenteApi.criar({ axios: this.$axios, base: this.base(), auth: this.auth() })
    this.carregar()
    this.carregarNos()
  },
  methods: {
    base () { return this.$store.state.config.baseUrlApi },
    auth () { return this.$store.getters.getHeaderAuth },
    vazio () { return { id: null, categoria: 'Educação', titulo: '', descricao: '', no_destino_id: null } },

    textoErro (e) {
      const r = e && e.response ? e.response : null
      if (!r) return 'Falha de comunicação com o servidor.'
      if (r.data && typeof r.data.erro === 'string') return r.data.erro
      if (r.data && r.data.erro && r.data.erro.text) return r.data.erro.text
      return 'Erro ' + r.status + ' ao consultar o servidor.'
    },

    carregar () {
      const self = this
      this.carregando = true
      this.api.carta_admin().then(function (r) {
        self.itens = (r.data && r.data.itens) || []
        self.problemas = (r.data && r.data.problemas) || []
        self.carregando = false
      }).catch(function () { self.carregando = false })
    },

    carregarNos () {
      const self = this
      this.api.fluxos().then(function (r) {
        const fluxos = r.data || []
        if (!fluxos.length) return
        self.api.arvore(fluxos[0].id).then(function (r2) { self.nos = (r2.data && r2.data.nos) || [] })
      })
    },

    novo () { this.form = this.vazio(); this.erro = null },
    editar (i) {
      this.form = { id: i.id, categoria: i.categoria, titulo: i.titulo,
                    descricao: i.descricao, no_destino_id: i.no_destino_id }
      this.erro = null
    },

    salvar () {
      if (this.salvando) return
      const self = this
      this.salvando = true
      this.erro = null
      this.api.salvarServico(this.form).then(function (r) {
        self.salvando = false
        self.form.id = r.data.id
        self.carregar()
        window.eventBus.$emit('alert', { msg: 'Serviço salvo (não publicado).', type: 'success' })
      }).catch(function (e) { self.salvando = false; self.erro = self.textoErro(e) })
    },

    publicar (i) {
      const self = this
      this.api.publicarServico(i.id).then(function (r) {
        if (r.data && r.data.erro) {
          window.eventBus.$emit('alert', { msg: r.data.erro, type: 'error' })
          return
        }
        self.carregar()
      }).catch(function (e) {
        window.eventBus.$emit('alert', { msg: self.textoErro(e), type: 'error' })
      })
    },

    despublicar (i) {
      const self = this
      this.api.despublicarServico(i.id).then(function () { self.carregar() })
    },
    remover (i) {
      const self = this
      this.api.removerServico(i.id).then(function () { self.carregar() })
    }
  }
}
</script>

<style scoped>
.estado { padding: 16px; text-align: center; color: #909399; font-size: 12px; }
.obs { font-size: 11px; color: #909399; }
.motivo { color: #E6A23C; font-size: 12px; }
</style>
